import {
    OPEN_CHAT_BY_QUERY_PARAM_REASON,
    OPEN_CHAT_QUERY_PARAM_TRIGGER,
    STATES,
    UTM_SOURCE_QUERY_PARAM,
} from './constants';
import { chatTriggeredEvent } from './bi';
import { isLoggedIn } from './utils';
import Forethought from './Forethought';
import { logger } from './logger';
import { clearCache, getOrInitCachedState } from './cache';
import { getForethoughtConfig } from './api';

export function enrichCachedState(cachedState) {
    const enrichedState = Object.assign({}, cachedState);
    const openSupportChat = new URLSearchParams(window.location.search).get(OPEN_CHAT_QUERY_PARAM_TRIGGER);
    const shallOpenSupportChat = openSupportChat === 'true';

    if (shallOpenSupportChat) {
        const utmSourceParam = new URLSearchParams(window.location.search).get(UTM_SOURCE_QUERY_PARAM);
        const reason = utmSourceParam ? `reason_${utmSourceParam}` : `reason_${OPEN_CHAT_BY_QUERY_PARAM_REASON}`;

        const userType = `user_type-${window.dataLayer && window.dataLayer[0].user_type}`;
        const tagsWithUserType = [...enrichedState.tags, reason, userType];

        Object.assign(enrichedState, { state: STATES.OPEN, tags: tagsWithUserType });

        chatTriggeredEvent(tagsWithUserType);
    }

    return enrichedState;
}

export async function initializeChat(state) {
    if (!isLoggedIn()) {
        return;
    }

    try {
        const forethoughtConfig = await getForethoughtConfig();
        const stateWithConfig = { ...state, forethoughtConfig };

        logger.debug('[Chat Init] Initializing Forethought with config:', forethoughtConfig);
        new Forethought(stateWithConfig);
    } catch (error) {
        logger.error('[Chat Init] Failed to initialize Forethought', error);
    }
}

export default async function main() {
    if (!window.axios) {
        return setTimeout(() => {
            if (main.retries === 10) {
                return;
            }

            main.retries = (main.retries || 0) + 1;
            main();
        }, 500);
    }

    if (!isLoggedIn()) {
        clearCache();

        return;
    }

    const cachedState = getOrInitCachedState();

    const enrichedState = enrichCachedState(cachedState);
    return initializeChat(enrichedState);
}
